import { render, staticRenderFns } from "./progressLabel.vue?vue&type=template&id=23124936&scoped=true&"
import script from "./progressLabel.vue?vue&type=script&lang=js&"
export * from "./progressLabel.vue?vue&type=script&lang=js&"
import style0 from "./progressLabel.vue?vue&type=style&index=0&id=23124936&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23124936",
  null
  
)

export default component.exports